export default "__VITE_ASSET__CR0qfwf3__"